import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@common/layout'
import commonRoutes from '@common/router'

Vue.use(VueRouter)

const routes = [
    {
        name: '401',
        path: '/401.html',
        meta: {
            isErrorPage: true,
        },
        component: () => import('../views/error-page/401'),
    },
    {
        name: '404',
        path: '/404.html',
        meta: {
            isErrorPage: true,
        },
        component: () => import('../views/error-page/404'),
    },
    {
        name: '503',
        path: '/503.html',
        meta: {
            isErrorPage: true,
        },
        component: () => import('../views/error-page/503'),
    },
    {
        name: 'main',
        path: '/app',
        component: () => import('../views/main/index'),
        children: [
            {
                name: 'main-index',
                path: ':appId/workspace/:workspaceId',
                component: Layout,
                redirect: {
                    name: 'index',
                },
                children: [
                    {
                        name: 'index',
                        path: 'design',
                        component: () => import('../views/designer/index'),
                    },
                    ...commonRoutes,
                ],
            },
           
        ],
    },
    {
        path: '*',
        redirect: { name: '404' },
    },
]

const router = new VueRouter({
    mode: 'history',
    routes,
})

export default router
